import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const reviewActivityQuery = gql`
  query ReviewActivity($sectionUid: ID!) {
    activityBySectionUidIfLatestMeetingNotReviewed(sectionUid: $sectionUid) {
      uid
      titleTranslated
      leader {
        name
        photo
      }
      details {
        photo
      }
    }
  }
`;

export default function useReviewActivity(sectionUid: string | null) {
  const { data, loading, error } = useQueryWithPreviousData(
    reviewActivityQuery,
    {
      variables: { sectionUid },
      skip: !sectionUid
    }
  );
  return {
    activity: data?.activityBySectionUidIfLatestMeetingNotReviewed,
    loading,
    error
  };
}
